var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSavedAnaylze = function SvgSavedAnaylze(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.79,
    height: 19.56,
    viewBox: "0 0 18.79 19.56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_6_zapisane_analizy"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.79,
    height: 19.56
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6_zapisane_analizy",
    "data-name": "6 zapisane analizy",
    clipPath: "url(#clip-_6_zapisane_analizy)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "analytics",
    transform: "translate(-7.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(15.542 2.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M169.076,57.551V56h-3.1v3.1h-2.326v5.428H171.4V57.551Zm-3.1,6.2h-1.551V59.877h1.551Zm2.326-6.2v6.2H166.75V56.775H168.3Zm2.326,6.2h-1.551V58.326h1.551Z",
    transform: "translate(-163.648 -56)",
    fill: "#a8b0b6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(7.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M19.419,0a7.358,7.358,0,0,0-6.147,11.415L8.339,16.347a1.164,1.164,0,0,0,0,1.645l1.23,1.23a1.164,1.164,0,0,0,1.645,0l5.157-5.157A7.363,7.363,0,1,0,19.419,0ZM10.665,18.673a.388.388,0,0,1-.548,0l-1.23-1.23a.388.388,0,0,1,0-.548l4.848-4.848a7.418,7.418,0,0,0,1.918,1.638Zm8.754-4.716A6.591,6.591,0,1,1,26.01,7.366,6.6,6.6,0,0,1,19.419,13.957Z",
    transform: "translate(-7.999)",
    fill: "#a8b0b6"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSavedAnaylze, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/saved_anaylze.b6c21bb0.svg";
export { ForwardRef as ReactComponent };